import { iterateCues } from './iterateCues';
import { buildCues, buildSelectorParts, BuildCues } from './cues';
import { querySelectorAll, SelectorPart } from './playwrightEvaluator';
import { getXpath } from './serialize';
import { getDirectInnerText } from './getDirectInnerText';

type IsMatch = {
  selectorParts: SelectorPart[];
  target: HTMLElement;
};

export const isMatch = ({ selectorParts, target }: IsMatch): boolean => {
  const result = querySelectorAll({ v1: { parts: selectorParts } }, document.body);

  // console.debug('Try selector', selectorParts[0], selectorParts[1], target);
  if(result.length > 1){
    return false
  }
  if (result[0] !== target && !target.contains(result[0])) {
    // console.error('Selector matches another element');
    return false;
  }

  return true;
};

export const toSelector = (selectorParts: SelectorPart[]): string => {
  const names = selectorParts.map((s) => s.name);

  // CSS selector
  if (!names.includes('text')) {
    return selectorParts.map((s) => s.body).join(' ');
  }

  // mixed selector
  return selectorParts.map(({ body, name }) => `${name}=${body}`).join(' >> ');
};
export const buildSelector = (options: BuildCues): string => {
  const tagName = options.target.tagName.toLowerCase();
  if (['body', 'html'].includes(tagName)) {
    return tagName;
  }
  const text = getDirectInnerText(options.target)
  if( !text.trim().match(/\n/) && isMatch({selectorParts: [{name: 'text', body: text.trim()}], target: options.target})){
    return ''
  }

  const cues = buildCues(options);
  for (const cueGroup of iterateCues(cues)) {
    const selectorParts = buildSelectorParts(cueGroup);
    if (isMatch({ selectorParts, target: options.target })) {
      const selector = toSelector(selectorParts);
      return selector;
    }
  }

  return `${getXpath(options.target)}`;
};
